import { render, staticRenderFns } from "./adminViewPEANotificationsByUser.vue?vue&type=template&id=4939f6c6"
import script from "./adminViewPEANotificationsByUser.vue?vue&type=script&lang=js"
export * from "./adminViewPEANotificationsByUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports